import { Country } from '@/domainLogic/index.ts';

export type ReassuranceMarket = {
  lang: string;
  href: string;
};

export const REASSURANCE_MARKETS: Partial<Record<Country, ReassuranceMarket>> = {
  [Country.GB]: { lang: 'en', href: 'https://www.lastminute.com/en/info/flight-hotel' },
  [Country.ES]: { lang: 'es', href: 'https://www.es.lastminute.com/es/info/vuelo-hotel' },
  [Country.IT]: { lang: 'it', href: 'https://www.it.lastminute.com/it/info/pacchetti-viaggio' },
  [Country.FR]: { lang: 'fr', href: 'https://www.fr.lastminute.com/fr/info/vol-hotel' },
  [Country.DE]: { lang: 'de', href: 'https://www.lastminute.de/de/info/flug-hotel' },
};
